import { Question } from "@types";
import { Flex, Space, Tooltip, Typography } from "antd";
import { Bookmark, CheckCircle, Circle, CircleDot } from "lucide-react";
import { stripHtmlTags } from "../../helpers";
import { useTranslation } from "react-i18next";

interface Props {
    onClick?: React.MouseEventHandler<HTMLDivElement> | undefined;
    question: Question;
    index: number;
    clickedQuestion?: Question;
}

export const QuestionsSiderListItem = ({onClick, question, index, clickedQuestion}: Props) => {
    const { t } = useTranslation();
    const isGraded = question.points !== null && question.points !== undefined;

    return (
        <div className={question.id === clickedQuestion?.id ? "custom-pick-clicked" : "custom-pick"} onClick={onClick} >
            <Flex justify="space-between" align="center">
                <Typography.Text className="question-line-clamp">{index+1}. {stripHtmlTags(question.text)}</Typography.Text>
                <Space size={4}>
                    {question.isBookmarked ? <Bookmark fill="currentColor" size={14} /> : ""}
                    {question.isAnswered ? <CheckCircle color="#F1B80E" size={14} /> : ""}
                    {isGraded ? (
                        <Tooltip title={t("pages.examPeriods.graded")}>
                            <CircleDot size={14} color="#52c41a" />
                        </Tooltip>
                    ) : (
                        <Tooltip title={t("pages.examPeriods.notGraded")}>
                            <Circle size={14} color="#d9d9d9" />
                        </Tooltip>
                    )}
                </Space>
            </Flex>
        </div>
    )
}